import { render, staticRenderFns } from "./CustomerVerificationPopUp.vue?vue&type=template&id=ce65cc86&"
import script from "./CustomerVerificationPopUp.vue?vue&type=script&lang=js&"
export * from "./CustomerVerificationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CustomerVerificationPopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports